(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-context-enquiry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-context-enquiry')) {
    class MSContextEnquiry extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const params = new URLSearchParams(window.location.search);
        const cleanText = (value, limit) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
        const firstParam = (keys, limit) => {
          for (const key of keys) {
            const value = cleanText(params.get(key), limit);
            if (value) return value;
          }
          return '';
        };
        const setValue = (selector, value) => {
          const field = this.querySelector(selector);
          if (field && !field.value && value) field.value = value;
        };
        const safeLink = (value) => {
          try {
            const url = new URL(cleanText(value, 2000));
            if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return '';
            return url.href.length <= 2000 ? url.href : '';
          } catch {
            return '';
          }
        };
        const source = this.querySelector('[data-enquiry-source]');
        if (source) source.value = cleanText(window.location.href, 2000);
        setValue('[data-enquiry-reference]', firstParam(['reference', 'ref', 'product', 'stone'], 200));
        setValue('[data-enquiry-report]', firstParam(['report', 'certificate'], 200));
        setValue('[data-enquiry-context]', firstParam(['source', 'context'], 240));
        setValue('[data-enquiry-link]', safeLink(firstParam(['reference_url', 'url', 'link'], 2000)));
        setValue('[data-enquiry-source-link]', safeLink(firstParam(['source_url'], 2000)));
      }
    }
    customElements.define('ms-context-enquiry', MSContextEnquiry);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-signature-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-catalog-browser')) {
    customElements.define('ms-catalog-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const requested = new URLSearchParams(window.location.search).get('category');
        const permitted = ['rings', 'bracelets', 'necklaces', 'earrings', 'engagement-rings', 'wedding-rings'];
        const category = permitted.includes(requested) ? requested : 'all';
        const links = [...this.querySelectorAll('[data-category-link]')];
        for (const link of links) {
          if (link.dataset.categoryLink === category) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        }
        let count = 0;
        for (const card of this.querySelectorAll('[data-catalog-product]')) {
          const finished = card.dataset.finishedCategory;
          const matches = category === 'all' || finished === category || (category === 'rings' && finished === 'wedding-rings');
          card.hidden = !matches;
          if (matches) count++;
        }
        for (const group of this.querySelectorAll('[data-catalog-group]')) {
          group.hidden = ![...group.querySelectorAll('[data-catalog-product]')].some(card => !card.hidden);
        }
        const empty = this.querySelector('[data-catalog-empty]');
        if (empty) empty.hidden = count > 0;
        const countLabel = this.querySelector('[data-catalog-count]');
        if (countLabel) countLabel.textContent = `${count} ${this.dataset.countLabel || ''}`.trim();
        const title = this.querySelector('[data-catalog-title]');
        const categoryLink = links.find(link => link.dataset.categoryLink === category);
        if (title && category !== 'all' && categoryLink) title.textContent = `${categoryLink.textContent.trim()} · ${title.textContent.trim()}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
